"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderBooking = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _globals = require("../../lib/constants/globals");
var _Actions = require("./Actions");
var _Availability = require("./Availability");
const ProviderBooking = _ref => {
  let {
    provider,
    modalDisplay,
    bookingCallback,
    shouldDisplayAvailability,
    slotsStatus,
    track,
    config,
    isBookingDisabled,
    showWarning,
    bookingWarning,
    onClickShowAvailability,
    locations,
    onTimeSlotsClick,
    onViewMoreClick,
    shouldRenderSlotsAsButtons,
    slots,
    bookOnlineUrl,
    apptInfo,
    slotsAriaProps,
    bookingOptionsButton,
    onAvailabilityTilesLoaded,
    summaryUrl
  } = _ref;
  const isHeadsUpAvailabilityEnabled = (0, _get2.default)(config, 'darkship_feature_flags.provider_tile_heads_up_availability', false);
  const slotsLoading = slotsStatus === _globals.SLOTS_LOADING_STATUS;
  const slotsExist = slotsStatus === _globals.SLOTS_SUCCESS_STATUS && slots && slots.length > 0;
  if (isHeadsUpAvailabilityEnabled && shouldDisplayAvailability && (slotsExist || slotsLoading)) {
    return /*#__PURE__*/_react.default.createElement(_Availability.Availability, {
      config: config,
      provider: provider,
      onTimeSlotsClick: onTimeSlotsClick,
      onViewMoreClick: onViewMoreClick,
      shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons,
      slots: slots,
      slotsStatus: slotsStatus,
      bookOnlineUrl: bookOnlineUrl,
      apptInfo: apptInfo,
      slotsAriaProps: slotsAriaProps,
      bookingOptionsButton: bookingOptionsButton,
      onAvailabilityTilesLoaded: onAvailabilityTilesLoaded,
      track: track
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Actions.Actions, {
    provider: provider,
    modalDisplay: modalDisplay,
    bookingCallback: bookingCallback,
    shouldDisplayAvailability: shouldDisplayAvailability,
    slotsStatus: slotsStatus,
    track: track,
    config: config,
    isBookingDisabled: isBookingDisabled,
    showWarning: showWarning,
    bookingWarning: bookingWarning,
    onClickShowAvailability: onClickShowAvailability,
    locations: locations,
    summaryUrl: summaryUrl
  });
};
exports.ProviderBooking = ProviderBooking;
ProviderBooking.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderBooking"
};